import { AccessorsMutatorsDecorator, Model } from "../../helpers";

/**
 * @class SmsAccountSettings
 * @property {number} id
 */
export class SmsAccountSettings extends Model {


}

AccessorsMutatorsDecorator('id', 'property_id', 'api_key', 'user_name', 'sender_name', 'total_sms_purchased', 'total_sms_used', 'balance', 'rate')(SmsAccountSettings);


// WEBPACK FOOTER //
// ./src/pms-api/models/sms-account-settings.model.js